import Button from "app/components/Button";
import Img from "app/components/Image";
import { _ } from "app/components/Translator";
import { useState } from "react";
import route from "ziggy-js";
import CateringButton from "../Buttons/CateringButton";
import { motion, AnimatePresence } from "framer-motion"

// DATA pro slideshow
const slides = [
    {
        first: {

            subtitle: "Ochutnejte",
            btnText: "Nezávazně poptat",
            /*  btnLink: route("kontakt"), */
            tags: [
                {
                    image: "/assets/img/catering/snidanove_brunchove_menu.jpg",
                    title: "Snídaňové a brunchové menu",
                    description: "Ráno dělá den. Nabízíme vám snídaně a brunche plné chuti – od našich fenomenálních vajec Benedikt až po domácí granolu s jogurtem a ovocem."
                },
                {
                    image: "/assets/img/catering/obedove_vecerove_speciality.jpg",
                    title: "Obědové a večeřové speciality",
                    description: "Italské těstoviny, šťavnatý hovězí steak nebo grilovaná ryba? Připravujeme jídla s důrazem na kvalitu, čerstvost a poctivou chuť."
                },
                {
                    image: "/assets/img/catering/sladke_pokuseni.jpg",
                    title: "Sladké pokušení",
                    description: "Zasloužený závěr každého menu – cheesecake, panna cotta, makronky nebo domácí zmrzlina. Dezerty, které potěší nejen chuťové buňky, ale i oči."
                },
                {
                    image: "/assets/img/catering/rauty_podle_vasi_chuti.jpg",
                    title: "Rauty podle vaší chuti",
                    description: "Vyberte si z teplého, studeného nebo sladkého cateringu, nebo si nechte připravit nabídku na míru – samozřejmě včetně vegetariánských a bezlepkových variant."
                },
                {
                    image: "/assets/img/catering/napoje.jpg",
                    title: "Nápoje pro každou příležitost",
                    description: "Italská káva, domácí limonády, výběrová vína i koktejly. Dopřejte si nápojový servis, který stylově doplní vaše menu."
                },
            ],
        },
    },
    {
        first: {

            subtitle: "Spolehlivě zajistíme",
            btnText: "Nezávazně poptat",
            /*  btnLink: route("kontakt"), */
            tags: [
                {
                    image: "/assets/img/catering/catering_pro_kazdou_prilezitost.jpg",
                    title: "Catering pro každou příležitost",
                    description: "Firemní večírek, narozeniny, svatba nebo konference – jsme tu pro vás od prvního nápadu až po poslední detail."
                },
                {
                    image: "/assets/img/catering/kompletni_servis.jpg",
                    title: "Kompletní servis včetně obsluhy",
                    description: "Naši profesionální číšníci, baristé a barmani se postarají o pohodlí vašich hostů a zajistí plynulý průběh celé akce."
                },
                {
                    image: "/assets/img/catering/dekorace_doprovodny_program.jpg",
                    title: "Dekorace a doprovodný program",
                    description: "Stylová výzdoba na klíč, živá hudba, DJ, stand-up comedy nebo řízené degustace. Dáme vaší akci osobitý ráz a atmosféru."
                },
                {
                    image: "/assets/img/catering/prostory_s_dusi.jpg",
                    title: "Prostory s duší",
                    description: "Pořádáme akce až pro 250 osob v našich prostorách v srdci Olomouce – vhodné pro školení, svatby, networking i kulturní události."
                },
                {
                    image: "/assets/img/catering/rozvoz_k_vam_domu.jpg",
                    title: "Rozvoz cateringu až k vám",
                    description: "Doručujeme catering po celé Olomouci a okolí – spolehlivě, bezpečně a včas. Cena za dopravu se odvíjí dle vzdálenosti a rozsahu zakázky."
                }
            ],
        },
    },
];

export default function ServicesSlideshowCatering() {

    const scrollToDemand = (e?: React.MouseEvent) => {
        e?.preventDefault?.();
        const el = document.getElementById('demand-card');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });

        }
    };
    return (
        <div className="flex flex-col   w-full">
            {slides.map((slide, slideIndex) => {
                const [activeTagIndex, setActiveTagIndex] = useState(0);

                const toggleTagSection = (index) => {
                    if (activeTagIndex === index) {

                        return;
                    } else {
                        setActiveTagIndex(index);
                    }
                };

                return (
                    <div
                        key={slideIndex}
                        className={`flex flex-col  md:flex-row ${slideIndex % 2 === 0 ? '' : 'md:flex-row-reverse'} gap-[24px] items-center`}
                    >
                        <div className="w-full md:w-1/2 aspect-square my-[32px] mob:mb-0 relative ">
                            <AnimatePresence>
                                {slide.first.tags.map((tag, tagIndex) =>
                                    activeTagIndex === tagIndex && (
                                        <motion.div
                                            key={tagIndex}
                                            initial={{ opacity: 0, scale: 0.9, x: -200, rotate: -6 }}
                                            animate={{ opacity: 1, scale: 1, x: 0, rotate: 0, transition: { delay: 0.07 } }}
                                            exit={{ opacity: 0, x: 200, rotate: 6, scale: 1 }}
                                            transition={{ ease: "easeIn" }}
                                            className="absolute inset-0 md:w-full"
                                            style={{}}
                                        >

                                            <Img
                                                src={slide.first.tags[activeTagIndex]?.image || ""}
                                                objectFit="cover"
                                                layout="responsive"
                                                className="w-full h-full"
                                            />
                                        </motion.div>
                                    )
                                )}
                            </AnimatePresence>
                        </div>
                        <motion.div
                            key={activeTagIndex}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { delay: 0.2 } }}
                            exit={{ opacity: 0 }}
                            transition={{ ease: "easeIn" }}
                            className="w-full md:w-1/2 flex flex-col justify-center md:px-[40px]"
                        >
                            {/* {slide.first.subtitle && <span className="uppercase text-[#666666] font-semibold mb-8px text-16 leading-24px "><_>{slide.first.subtitle}</_></span>} */}
                            <ul className="space-y-12px">
                                {slide.first.tags?.map((tag, tagIndex) => (
                                    <li
                                        key={tagIndex}
                                        className={`text-[#666666] pb-12px text-14 cursor-pointer ${activeTagIndex !== tagIndex ? 'border-b border-[#E0DCD8]' : ''}`}
                                        onClick={() => toggleTagSection(tagIndex)}
                                    >
                                        {activeTagIndex !== tagIndex && (
                                            <span className="text-[16px] font-bold">
                                                <_>{tag.title}</_>
                                            </span>
                                        )}
                                        {activeTagIndex === tagIndex && (
                                            <div className="mt-24px mob:mt-0">
                                                {slide.first.subtitle && (
                                                    <span className="block uppercase mt-24px mob:mt-0 mob:mb-8px text-[#666666] font-semibold  text-16 leading-24px">
                                                        <_>{slide.first.subtitle}</_>
                                                    </span>
                                                )}
                                                <span className="text-[32px]  mob:text-[24px] leading-[40px] text-black font-semibold">
                                                    <_>{tag.title}</_>
                                                </span>
                                                <p className="text-[16px] mob:mt-16px"><_>{tag.description}</_></p>
                                                <CateringButton
                                                    className="mt-24px mob:font-bold"
                                                    value={slide.first.btnText}
                                                    onClick={scrollToDemand}

                                                />
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                );
            })}
        </div>
    );
}
